// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__21VPa","buttons":"Footer_buttons__2wuZN"};